<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" width="80%">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="form" :model="formData" :label-width="160">
          <Row>
            <Col span="8">
<!--              <FormItem label="所属地区" prop="place.id" :rules="[rules.requiredNumber]">-->
              <FormItem label="所属地区" prop="place.id">
                <place-sel v-model="formData.place.id"></place-sel>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="机械颜色" prop="equipColor">
                <color-sel v-model="formData.equipColor"></color-sel>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="机械商标" prop="tradeMark">
                <Input v-model="formData.tradeMark" placeholder="机械商标"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
<!--              <FormItem label="目前所在城市" prop="currentPlace" :rules="[rules.required]">-->
              <FormItem label="目前所在城市" prop="currentPlace">
                <Input v-model="formData.currentPlace" placeholder="目前所在城市"></Input>
              </FormItem>
            </Col>
            <Col span="8">
<!--              <FormItem label="使用地点类型" prop="placeType" :rules="[rules.requiredNumber]">-->
              <FormItem label="使用地点类型" prop="placeType">
                <Select v-model="formData.placeType" placeholder="使用地点类型" style="width:200px;">
                  <Option :value="0">施工工地</Option>
                  <Option :value="1">港口</Option>
                  <Option :value="2">机场</Option>
                  <Option :value="3">物流园区</Option>
                  <Option :value="4">铁路货场</Option>
                  <Option :value="5">大型工矿企业</Option>
                </Select>
              </FormItem>
            </Col>

            <Col span="8">
<!--              <FormItem label="使用地点" prop="usedPlace" :rules="[rules.required]">-->
              <FormItem label="使用地点" prop="usedPlace">
                <Input v-model="formData.usedPlace" placeholder="请输入使用地点"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
<!--              <FormItem label="环保登记号码" prop="epNo" :rules="[rules.required]">-->
              <FormItem label="环保登记号码" prop="epNo">
                <Input v-model="formData.epNo" placeholder="环保登记号码"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="车牌号" prop="plateNo">
                <Input v-model="formData.plateNo" placeholder="车牌号"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="国产/进口" prop="equipImport">
                <RadioGroup v-model="formData.equipImport">
                  <Radio :label="0">国产</Radio>
                  <Radio :label="1">进口</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="检测单位" prop="departmentId">
                <depart-sel v-model="formData.departmentId" :departmentType="1" width="200px" placeholder="请选择检测单位"></depart-sel>
              </FormItem>
            </Col>
            <Col span="8">
<!--              <FormItem label="所有人" prop="ownerName" :rules="[rules.required]">-->
              <FormItem label="所有人" prop="ownerName">
                <Input v-model="formData.ownerName" placeholder="所有人"></Input>
              </FormItem>
            </Col>
            <Col span="8">
<!--              <FormItem label="所有人联系方式" prop="ownerContact" :rules="[rules.required]">-->
              <FormItem label="所有人联系方式" prop="ownerContact">
                <Input v-model="formData.ownerContact" placeholder="所有人联系方式"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
<!--              <FormItem label="身份证号/统一社会信用代码" prop="idNo" :rules="[rules.required]">-->
              <FormItem label="身份证号/统一社会信用代码" prop="idNo">
                <Input v-model="formData.idNo" placeholder="身份证号/统一社会信用代码"></Input>
              </FormItem>
            </Col>
            <Col span="16">
              <FormItem label="联系地址" prop="ownerAddress">
                <Input v-model="formData.ownerAddress" placeholder="联系地址"></Input>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="8">
              <FormItem label="身份证/营业执照照片" prop="cardPic">
                <do-picture v-model="formData.cardPic"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="身份证反面照片" prop="cardVersoPic">
                <do-picture v-model="formData.cardVersoPic"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="所属证明照片" prop="ownerVoucher" >
                <do-picture v-model="formData.ownerVoucher"></do-picture>
              </FormItem>
            </Col>
          </Row>

          <Row><Col offset="1"><span class="form-tip">* 机械机身三张不同角度照片，必填</span></Col></Row>
          <Row>
            <Col span="8">
<!--              <FormItem label="机械正面" prop="equipPic1" :rules="[rules.required]">-->
              <FormItem label="机械正面" prop="equipPic1">
                <do-picture v-model="formData.equipPic1"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
<!--              <FormItem label="机械后面" prop="equipPic2" :rules="[rules.required]">-->
              <FormItem label="机械后面" prop="equipPic2">
                <do-picture v-model="formData.equipPic2"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
<!--              <FormItem label="机械侧面45度" prop="equipPic3" :rules="[rules.required]">-->
              <FormItem label="机械侧面45度" prop="equipPic3">
                <do-picture v-model="formData.equipPic3"></do-picture>
              </FormItem>
            </Col>
          </Row>
          <Row><Col offset="1"><span class="form-tip">进口机械需提供进口凭证、购置发票照片</span></Col></Row>
          <Row>
            <Col span="8">
              <FormItem label="进口凭证照片" prop="importVoucherPic">
                <do-picture v-model="formData.importVoucherPic"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="购置发票照片" prop="invoicePic">
                <do-picture v-model="formData.invoicePic"></do-picture>
              </FormItem>
            </Col>
          </Row>
          <Row><Col offset="1"><span class="form-tip">其他照片指除了机械铭牌、发动机铭牌和信息公开标签外，其他固定在机械机身上的永久号码照片以及出厂合格证照片等</span></Col></Row>
          <Row>
            <Col span="8">
              <FormItem label="发动机铭牌照片" prop="enginePic">
                <do-picture v-model="formData.enginePic"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="机械铭牌照片" prop="equipPlatePic">
                <do-picture v-model="formData.equipPlatePic"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="机械环保信息标签照片" prop="epPic" >
                <do-picture v-model="formData.epPic"></do-picture>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="机械环保代码照片" prop="epNoPic">
                <do-picture v-model="formData.epNoPic"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="合格证照片" prop="certificationPic">
                <do-picture v-model="formData.certificationPic"></do-picture>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="其他照片" prop="otherPic">
                <do-picture v-model="formData.otherPic"></do-picture>
              </FormItem>
            </Col>
          </Row>

          <Row><Col offset="1"><span class="form-tip">* 有铭牌机械，机械环保代码、机械环保信息公开号、发动机型式核准号、机械产品识别码必填之一</span></Col></Row>
          <Row>
            <Col span="8">
              <FormItem label="机械环保代码" prop="equipEpNo" >
                <Input v-model="formData.equipEpNo" placeholder="机械环保代码"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="机械环保信息公开号" prop="engineFactoryNo" >
                <Input v-model="formData.epPubNo" placeholder="机械环保信息公开号"></Input>
              </FormItem>

            </Col>
            <Col span="8">
              <FormItem label="其他永久性号码" prop="otherNo" >
                <Input v-model="formData.otherNo" placeholder="其他永久性号码"></Input>
              </FormItem>

            </Col>
          </Row>


          <Row>
            <Col span="8">
<!--              <FormItem label="机械类型" prop="equipmentType.id" :rules="[rules.requiredNumber]">-->
              <FormItem label="机械类型" prop="equipmentType.id">
                <etype-sel v-model="formData.equipmentType.id"></etype-sel>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="(机械/车辆)产品识别码(PIN码/VIN码)" prop="pinNo" >
                <Input v-model="formData.pinNo" placeholder="(机械/车辆)产品识别码(PIN码/VIN码)"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="录入日期" prop="enteringDate">
                <DatePicker type="date" placeholder="机械录入日期" format="yyyy-MM-dd" :value="formData.enteringDate" @on-change="etdChange" style="width:200px;"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="车牌颜色" prop="plateColor">
                <Input v-model="formData.plateColor" placeholder="车牌颜色"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="整车质量" prop="equipWeight">
                <Input v-model="formData.equipWeight" type="number" placeholder="整车质量">
                  <Button slot="append">KG</Button>
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="最大质量" prop="maxWeight">
                <Input v-model="formData.maxWeight" type="number" placeholder="最大质量">
                  <Button slot="append">KG</Button>
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="机械型号" prop="typeName" >
                <Input v-model="formData.typeName" placeholder="机械型号"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="工作特性" prop="performance">
                <RadioGroup v-model="formData.performance">
                  <Radio :label="0">非恒速</Radio>
                  <Radio :label="1">恒速</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="是否禁排区工作" prop="jpqWork">
                <RadioGroup v-model="formData.jpqWork">
                  <Radio :label="0">否</Radio>
                  <Radio :label="1">是</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="机械制造企业" prop="factoryName">
                <Input v-model="formData.factoryName" placeholder="机械制造企业"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="机械出厂编号" prop="equipFactoryNo">
                <Input v-model="formData.equipFactoryNo" placeholder="机械出厂编号"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="机械出厂日期" prop="productionDate">
                <DatePicker type="date" placeholder="机械出厂日期" format="yyyy-MM-dd" :value="formData.productionDate" @on-change="pdChange" style="width:200px;"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="发动制造企业" prop="engineFactoryName">
                <Input v-model="formData.engineFactoryName" placeholder="请输入发动制造企业"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="发动机出厂编号" prop="engineFactoryNo" >
                <Input v-model="formData.engineFactoryNo" placeholder="发动机出厂编号"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="发动机出厂日期" prop="engineProductionDate">
                <DatePicker type="date" placeholder="发动机出厂日期" format="yyyy-MM-dd" :value="formData.engineProductionDate" @on-change="epdChange" style="width:200px;"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="发动机型号" prop="engineType">
                <Input v-model="formData.engineType" placeholder="请输入发动机型号"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="发动机型形式核准号" prop="engineTaNo" >
                <Input v-model="formData.engineTaNo" placeholder="发动机型形式核准号"></Input>
              </FormItem>
            </Col>
            <Col span="8">
<!--              <FormItem label="排放阶段" prop="emissionStandards" :rules="[rules.requiredNumber]">-->
              <FormItem label="排放阶段" prop="emissionStandards">
                <Select v-model="formData.emissionStandards" placeholder="燃料种类" style="width:200px;">
                  <Option :value="0">电动</Option>
                  <Option :value="1">第一排放阶段</Option>
                  <Option :value="2">第二排放阶段</Option>
                  <Option :value="3">第三排放阶段</Option>
                  <Option :value="4">第四排放阶段</Option>
                  <Option :value="5">第五排放阶段</Option>
                  <Option :value="6">第六排放阶段</Option>
                  <Option :value="-1">排放阶段不详</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="发动机额定功率(KW)" prop="engineRatedPower">
                <InputNumber v-model="formData.engineRatedPower" placeholder="请输入发动机额定功率" style="width:200px;"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="发动机额定转速" prop="engineRatedSpeed" >
                <InputNumber v-model="formData.engineRatedSpeed" :step="100" placeholder="请输入发动机额定转速" style="width:200px;"></InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="燃料种类/电动" prop="bunkersType">
                <Select v-model="formData.bunkersType" placeholder="燃料种类" style="width:200px;">
                  <Option :value="0">汽油</Option>
                  <Option :value="1">柴油</Option>
                  <Option :value="2">LPG</Option>
                  <Option :value="3">CNG</Option>
                  <Option :value="4">油气混合动力</Option>
                  <Option :value="5">油电混合动力</Option>
                  <Option :value="6">电动</Option>
                  <Option :value="7">其他</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="燃料喷射系统形式" prop="ngInjection">
                <Select v-model="formData.ngInjection" placeholder="燃料喷射系统形式" style="width:200px;">
                  <Option :value="1">机械泵</Option>
                  <Option :value="2">分配泵</Option>
                  <Option :value="3">直列泵</Option>
                  <Option :value="4">泵喷嘴</Option>
                  <Option :value="5">高压共轨</Option>
                  <Option :value="6">混合装置</Option>
                  <Option :value="7">其他</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="发动机后处理装置" prop="afterProcess">
                <Select v-model="formData.afterProcess" placeholder="发动机后处理装置" style="width:200px;">
                  <Option value="0">无</Option>
                  <Option value="1">SCR</Option>
                  <Option value="2">DPF</Option>
                  <Option value="3">POC</Option>
                  <Option value="4">OBD</Option>
                  <Option value="5">ECU</Option>
                  <Option value="6">EGR</Option>
                  <Option value="7">催化转化器</Option>
                  <Option value="8">增压器</Option>
                  <Option value="9">中冷器</Option>
                  <Option value="10">喷油泵</Option>
                  <Option value="11">喷油器</Option>
                  <Option value="12">空气滤清器</Option>
                  <Option value="13">进气消声器</Option>
                  <Option value="14">排气消声器</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem v-show="formData.afterProcess != '0'" label="后处理器型号" prop="afterProcessType">
                <Input v-model="formData.afterProcessType" placeholder="后处理器型号"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem v-show="formData.afterProcess != '0'" label="后处理器生产厂" prop="afterProcessManu">
                <Input v-model="formData.afterProcessManu" placeholder="后处理器生产厂"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="16">
              <FormItem label="转让信息" prop="transferMark">
                <Input v-model="formData.transferMark" type="textarea" placeholder="转让信息"></Input>
              </FormItem>
            </Col>
          </Row>

        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="primary" @click="handleSubmit">确定</Button>
        </div>
    </Modal>
</template>

<script>
    import iEquip from "@/module/main/api/iEquip";
    import modalHelper from "@/mixins/modalHelper";
    import DoPicture from '_c/auto-form/DoPicture';
    import DoPictureList from '_c/auto-form/DoPicturelist';
    import PlaceSel from '@/module/main/components/PlaceSel';
    import EtypeSel from '@/module/main/components/EtypeSel';
    import ColorSel from '@/module/main/components/ColorSel';
    import DepartSel from '@/module/main/components/DepartSel';
    import rules from '@/libs/rules';
    import _don from "@/libs/doson";

    const formModal = {
        id:null,
        plateNo:null,
        epNo:null,
        equipUuid:null,
        departmentId:null,
        equipmentType:{id:null},
        ownerId:null,
        ownerName:null,
        ownerContact:null,
        cardPic:null,
        cardVersoPic:null,
        ownerVoucher:null,
        equipPic:null,
        equipPic1:null,
        equipPic2:null,
        equipPic3:null,
        place:{id:null},
        equipEpNo:null,
        engineTaNo:null,
        engineFactoryNo:null,
        equipFactoryNo:null,
        factoryName:null,
        productionDate:null,
        engineProductionDate:null,
        engineRatedPower:null,
        engineRatedSpeed:null,
        engineFactoryName:null,
        engineType:null,
        emissionStandards:null,
        bunkersType:null,
        otherNo:null,
        usedPlace:null,
        afterProcess:'0',
        emergencyRescue:0,
        status:0,
        terminal:null,
        typeName:null,//机械型号
        idNo:null,//身份证号/统一社会信用代码
        pinNo:null,//PIN码
        placeType:0,//使用地点类型
        epPic:null,//环保标签照
        enginePic:null,//发动机铭牌照
        equipPlatePic:null,//设备铭牌照
        addTime:null,
        currentPlace:null,
        epNoPic:null,
        otherPic:null,
        epPubNo:null,
        importVoucherPic:null,
        invoicePic:null,
        equipColor:null,
        tradeMark:null,
        enteringDate:null,
        equipImport:0,
        ownerAddress:null,
        equipWeight:null,
        maxWeight:null,
        plateColor:null,
        transferMark:null,
        ngInjection:1,
        performance:0,
        certificationPic:null,
        afterProcessType:null,
        afterProcessManu:null,
        jpqWork:0
    };

    export default {
        name: "equip-edit",
        mixins: [modalHelper],
        components: {
            DoPicture,PlaceSel,DoPictureList,EtypeSel,ColorSel,DepartSel
        },
        data() {
            return {
                rules,
                formData: _don.cloneWithModal(formModal),
                region: [],
                upOption:{uploadMaxCount:3},
                defaultWidth:'200px'
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);
                if (this.formData.equipPic) {
                    let arr = this.formData.equipPic.split(',')
                    arr.length > 0 && (this.formData.equipPic1=arr[0])
                    arr.length > 1 && (this.formData.equipPic2=arr[1])
                    arr.length > 2 && (this.formData.equipPic3=arr[2])
                }
            },
            async handleSubmit() {
                if (!await this.$refs.form.validate()) return;
                /*if (!this.formData.equipEpNo && !this.formData.engineTaNo && !this.formData.engineFactoryNo) {
                    this.$Message.error('机械环保代码、发动机型形式核准号、发动机出厂编号至少要填写一项')
                    return;
                }*/
                let equipPicArr = []
                equipPicArr.push(this.formData.equipPic1||'')
                equipPicArr.push(this.formData.equipPic2||'')
                equipPicArr.push(this.formData.equipPic3||'')
                this.formData.equipPic = equipPicArr.join(',')
                // 提交
                if (this.formData.id) {
                    iEquip.equipUpdate(this.formData).then(() => {
                        this.$Message.success('操作成功');
                        this.$emit('on-success', this.formData);
                        this.currValue = false;
                    }).loadingSwitch(this, 'loading');
                } else {
                    iEquip.equipAdd(this.formData).then(() => {
                        this.$Message.success('操作成功');
                        this.$emit('on-success', this.formData);
                        this.currValue = false;
                    }).loadingSwitch(this, 'loading');
                }
            },
            pdChange(v) {
                this.formData.productionDate = v
            },
            epdChange(v) {
                this.formData.engineProductionDate = v
            },
            etdChange(v) {
                this.formData.enteringDate = v
            },
        },
        computed: {
            title() {
                return '机械档案' + (this.formData.id?'编辑':'添加');
            }
        },
        watch:{

        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:28px;
    }
</style>
